<template>
  <div>
    <div class="row mt-0">
      <div class="col-12 col-md-6 col-lg-4">
        <atom-input
          v-model="crossConnectFilter.idcId"
          :title="contractIdLabel"
          :placeholder="contractIdLabel"
          type="number"
          :maxLength="8"
        ></atom-input>
      </div>
      <div class="col-12 col-md-6 col-lg-4 mt-1 mt-md-0">
        <atom-input
          v-model="crossConnectFilter.customerName"
          title="Customer Name"
          placeholder="Customer Name"
        ></atom-input>
      </div>
      <div class="col-12 col-lg-4 mt-1 mt-lg-0">
        <atom-select
          v-model="crossConnectFilter.status"
          title="Status"
          placeholder="All Status"
          label="name"
          :option="crossConnectStatusOption"
        ></atom-select>
      </div>
    </div>
    <div class="row mt-1">
      <div class="col-12 col-lg-4">
        <atom-select
          v-model="crossConnectFilter.staff"
          title="Staff"
          placeholder="All Staff"
          label="name"
          :option="crossConnectStaffOption"
        ></atom-select>
      </div>
    </div>
  </div>
</template>

<script>
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import mixins from '@/mixins'

export default {
  name: "MoleculeReportFilterCrossConnect",
  components: { AtomSelect, AtomInput },
  mixins: [mixins],
  props: {
    value: {
      type: Object,
      required: true,
    },
    crossConnectStatusOption: {
      type: Array,
      required: true,
    },
    crossConnectStaffOption: {
      type: Array,
      required: true,
    },
  },

  computed: {
    crossConnectFilter: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit("input", newValue)
      },
    },
  },
}
</script>

<style></style>
